module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DialogBox', {
    attrs: {
      "settings": _vm.settings
    },
    on: {
      "show": _vm.initialiseDialog
    }
  }, [_c('div', {
    staticClass: "pa-4"
  }, [_c('div', {
    staticClass: "section-heading vertical-margin"
  }, [_vm._v("Main")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Title"
    },
    model: {
      value: (_vm.element.title),
      callback: function($$v) {
        _vm.$set(_vm.element, "title", $$v)
      },
      expression: "element.title"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Name"
    },
    model: {
      value: (_vm.element.name),
      callback: function($$v) {
        _vm.$set(_vm.element, "name", $$v)
      },
      expression: "element.name"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "section-heading vertical-margin"
  }, [_vm._v("Display")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": [1, 2],
      "label": "Columns"
    },
    model: {
      value: (_vm.element.columns),
      callback: function($$v) {
        _vm.$set(_vm.element, "columns", $$v)
      },
      expression: "element.columns"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "width": "100%"
    }
  }, _vm._l((_vm.element.columns), function(column, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "margin-right": "5px",
        "flex-grow": "1"
      }
    }, [_c('div', {
      staticClass: "section-heading vertical-margin"
    }, [_vm._v("Column " + _vm._s(index + 1))]), _vm._v(" "), _c('v-text-field', {
      attrs: {
        "label": "Title"
      },
      model: {
        value: (column.title),
        callback: function($$v) {
          _vm.$set(column, "title", $$v)
        },
        expression: "column.title"
      }
    })], 1)
  }), 0)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-780e4da0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/builder/ElementDialog.vue
// module id = 2612
// module chunks = 1